import { ComponentType } from 'react';

import { useGetMeQuery } from '@/api/auth/api';
import { Auth } from '@/shared/security/hasPermission';

export const withSecurity = <T extends object>(
  Component: ComponentType<T & { auth: Auth }>,
) => {
  return (props: Omit<T, 'auth'>) => {
    const { data, isLoading } = useGetMeQuery();

    if (isLoading || !data?.auth) {
      return null;
    }

    return (
      <Component
        {...(props as T)}
        auth={{ ...data.auth, organization: data.organization }}
      />
    );
  };
};
